import {
  Component,
  ViewChild
} from '@angular/core';
import * as _ from 'lodash';

import { SortModel } from '../search/sort.model';

import { SearchFormComponent } from '../search/search-form/search-form.component';


@Component({
  template: ''
})
export class FrontendSearchWidgetComponent {

  @ViewChild(SearchFormComponent, {static: false})
  searchForm: SearchFormComponent;

  columns: any;
  sortModel: SortModel;
  data: Array<any> = [];
  selectedData: Array<any> = [];
  selectedAll: boolean = false;
  // define in class
  searchFilterField: string = 'name';
  searchTerm: string = '';

  get searchResultsData(): Array<any> {
    if (this.sortModel) {
      const order: Array<boolean | 'asc' | 'desc'> = this.sortModel.sort === 'asc' ? ['asc'] : ['desc'];
      return _.orderBy(
        this.filterByField(this.data),
        [this.sortModel.column], order
      );
    } else {
      return this.filterByField(this.data);
    }
  }

  get searchTermValue(): string {
    if (this.searchForm) {
      return this.searchForm.searchTermValue;
    } else if (this.searchTerm) {
      return this.searchTerm;
    } else {
      return '';
    }
  }

  get selected(): Array<any> {
    return _.filter(this.data, 'selected');
  }

  resetData() {
    this.data = [];
    this.sortModel = null;
    this.selectedAll = false;
    this.selectedData = [];
    this.searchTerm = '';
    if (this.searchForm) { this.searchForm.resetValue(); }
  }

  removeSelectedItem(item: any) {
    _.pull(this.selectedData, item);
  }

  // handlers
  onSelectAllChange(isSelected: boolean) {
    this.changeSelectedAll(isSelected);
  }

  onCheckboxChange(item: any) {
    this.selectedAll = false;
    if (item.selected) {
      this.selectedData.push(item);
    } else {
      this.removeSelectedItem(item);
    }
  }

  onSortChanged(sortModel: SortModel) {
    this.sortModel = sortModel;
  }

  protected addColToData(colName: string) {
    const col: any = _.find(this.columns, {sortName: colName});
    if (!col) { return; }

    // add column value to the data
    _.forEach(this.data, (item: any) => {
      item[colName] = col.data(item);
    });
  }

  protected changeSelectedAll(isSelected: boolean) {
    this.selectedAll = isSelected;
    const filteredItems = this.filterByField(this.data);
    filteredItems.map((item: any) => {
      if (item.uncheckable) { return; }
      if (isSelected) {
        if (!item.selected) { this.selectedData.push(item); }
      } else {
        _.remove(this.selectedData, item);
      }
      item.selected = isSelected;
    });
  }

  protected filterByField(data: any): Array<any> {
    if (!this.searchTermValue) { return data; }
    return _.filter(data, (item: any) => {
      return item[this.searchFilterField]
      .toLowerCase()
      .indexOf(this.searchTermValue.toLowerCase()) !== -1;
    });
  }
}
